import * as React from "react";
import { connect } from "react-redux";
import { formatDate } from "../../../../../utils/DateFormat";
import { Pagination } from "@vwpfs/mary-air-lib/components/air/06-molecules/Pagination";
import { RowData, Table } from "@vwpfs/mary-air-lib/components/air/06-molecules/Table";
import { DispatchFunc } from "../../../../../store/ActionTypes";
import { Brands } from "../../../../../store/Brand/Types";
import { updateModelOnBrandChange } from "../../../../../store/Policies/EditPolicyTypes";
import { PolicyRequest } from "../../../../../store/Policies/Types";
import { ReduxState, isRemoteLoading } from "../../../../../store/ReduxState";
import { remoteTrigger } from "../../../../../store/RemoteActions";
import { RemoteScope } from "../../../../../store/RemoteTypes";
import { ThemePalette } from "@vwpfs/mary-air-lib/theme/_Types";
import { TableSelectCell } from "../../../06-molecules/TableSelectCell";
import { Container } from "@vwpfs/mary-air-lib/components/air/03-base/Container";


interface State {
    selectedRows: string[];
}

/**
 *
 */
interface StateProps {
    policy: PolicyRequest;
    loading: boolean;
}

/**
 *
 */
interface OwnProps {
    results: Brands;
    onChange: <K extends keyof PolicyRequest>(key: K, value: PolicyRequest[K]) => void;
    brandNumber?: string;
}

/**
 *
 */
interface DispatchProps {
    loadResults: (skip: number) => void;
    loadModelResults: (brandName: string) => void;
}

/**
 *
 */
type Props = OwnProps & StateProps & DispatchProps;

/**
 *
 */
export const mapStateToProps = (s: ReduxState): StateProps => ({
    policy: s.prop("policyRequest")?.map(e => ({
        ...e,
    })),
    loading:
            isRemoteLoading(s, RemoteScope.BRAND_RESULTS)
    ,
});

/**
 *
 */
export const mapDispatchToProps = (dispatch: DispatchFunc): DispatchProps => ({
    loadResults: (skip: number) => dispatch(remoteTrigger(RemoteScope.BRAND_RESULTS, {
        skip: skip,
    })),
    loadModelResults: (brandName: string) => dispatch(remoteTrigger(RemoteScope.MODEL_PER_BRAND_RESULTS, {
        skip: 0,
        brandName: brandName,
        onSuccess: () =>  dispatch(updateModelOnBrandChange()),
    })),
});

/**
 *
 */
export class ResultsComp
    extends React.Component<Props, State> {

    /**
     *
     * @param props
     * @param ctx
     */
    public constructor(props: Props, ctx?: {}) {
        super(props, ctx);

        this.state = this.refreshedRowState();
        this.selectItem = this.selectItem.bind(this);
        this.refreshedRowState = this.refreshedRowState.bind(this);
        this.handlePageClick = this.handlePageClick.bind(this);
        this.amIChecked = this.amIChecked.bind(this);
        this.getProcessedRows = this.getProcessedRows.bind(this);
        this.resultsData = this.resultsData.bind(this);
    }

    /**
     *
     */
    public render() {
        return (
            <React.Fragment>
                <Table
                    hasActions
                    data={{
                        columns: this.resultsData().columns,
                        rows: this.resultsData().rows,
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                        sort: this.resultsData().sort,
                    }}
                />
                {(this.props.results && this.props.results.totalPages && this.props.results.totalPages > 1) ?
                    <Container
                        className="scl-h-text-align--center"
                        theme={{
                            padding: { "": { t: 3, b: 2 }, "sm": { t: 4, b: 3 } },
                        }}
                    >
                        <Pagination
                            pageCount={this.props.results.totalPages}
                            currentPage={this.props.results.number}
                            onPageChange={this.handlePageClick}
                            theme={{ palette: ThemePalette.CONTRAST_PRIMARY }}
                        />
                    </Container> : null}
            </React.Fragment>
        );
    }

    private selectItem(value: boolean | undefined, name: string) {
        this.setState({
            selectedRows: !!value ? [
                name,
            ] : [],
        },
        () => {
            this.props.onChange("brand", this.state.selectedRows[0]);
            this.props.loadModelResults(this.state.selectedRows[0]);
        });
    }

    /**
     *
     */
    private refreshedRowState(): State {
        return {
            selectedRows: this.props.brandNumber ? [this.props.brandNumber] : [],
        };
    }

    private handlePageClick(skip: number) {
        this.props.loadResults(skip);
    }

    private amIChecked(name: string, selectedRows: string[]): boolean {
        return selectedRows.some((row) => row === name);
    }

    /**
     *
     */
    private getProcessedRows(): RowData[] {
        return this.props.results.content?.map((row, index) => {
            const checked = this.amIChecked(row.name, this.state.selectedRows);
            return ({
                id: row.id,
                data: [
                    (
                        <TableSelectCell
                            key={`table-cel-${row.id}`}
                            checked={checked}
                            selectItem={() => this.selectItem(!checked, row.name)}
                        />
                    ),
                    row.name ? row.name : "",
                    row.commercialVehicles && row.passengerVehicles ? "Passenger & Commercial"
                        : row.passengerVehicles ? "Passenger"
                            : row.commercialVehicles ? "Commercial"
                                : "",
                    row.createdAt
                        ? <span key={`c-date-${index}`}>
                            {formatDate(new Date(row.createdAt), "DD-MM-YYYY")}
                        </span>
                        : "",
                    row.description,
                ],
            });
        });
    }

    /**
     *
     */
    private resultsData() {
        return {
            sort: undefined,
            columns: [
                {
                    label: "Select",
                },
                {
                    label: "Name",
                },
                {
                    label: "Type",
                },
                {
                    label: "Created at",
                },
                {
                    label: "Description",
                },
            ],
            rows: this.getProcessedRows(),
        };
    }
}

/**
 *
 */
export const Results = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ResultsComp);
